var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-icon',{class:_vm.iconClass,attrs:{"color":"success","small":_vm.isProduto || _vm.small}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}],null,false,1795282570)},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }